import { Component } from '@angular/core';

@Component({
    selector: 'app-switch-to-automatic-transfer',
    templateUrl: './switch-to-automatic-transfer-of-annual-result.component.html',
    styleUrls: ['./switch-to-automatic-transfer-of-annual-result.component.scss']
})
export class SwitchToAutomaticTransferOfAnnualResultComponent {


}
